import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_MS_OAUTH_CLIENT_ID,
    redirectUri: process.env.NEXT_PUBLIC_MS_OAUTH_REDIRECT_URL,
  },
};

let msalInstance: PublicClientApplication | null = null;
export const getMsalInstance = () => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
  }
  return msalInstance;
};
